import { Action } from "redux";
import { Buffer, delay, Pattern, Task } from "redux-saga";
import { actionChannel, CallEffectFn, cancel, fork, Func0, take } from "redux-saga/effects";

/**
 * Ignores consequent calls of task if action arrives before specified interval.
 */
export const debounce = (ms: number, pattern: Pattern, task: CallEffectFn<Func0>, ...args: any[]) =>
    fork(function*() {
        // Requirements:
        // * Ignore actions arrived withing interval
        // * Start task with latest action after interval
        // * If more task arrives after starting but before finishing the task, cancel the task

        const delayChannel = yield actionChannel(pattern, new ArrayBuffer());

        let latestTask: Task | undefined = undefined;
        let iteration = 0;
        const log = (message: string, ...args: any[]) => {
            if (iteration > 0) {
                // console.log(`I${iteration}: ${message}`, ...args);
            }
        };

        function* runTask(action: Action) {
            log("Running processing of action", action);
            log(`Delaying ${ms}ms`);
            yield delay(ms);
            log("Delay passed");
            const result = yield (fork as any)(task, ...args, action);
            log("Task forked");
            return result;
        }

        while (true) {
            const action = yield take(delayChannel);
            log("Run debounce iteration. Action received ", action);

            if (latestTask) {
                log("Task cancelled");
                yield cancel(latestTask);
            }

            log("Running new task");
            latestTask = yield* runTask(action);

            iteration++;
        }
    });

class ArrayBuffer implements Buffer<Action<any>> {
    private content: Action<any>[] = [];

    isEmpty(): boolean {
        return this.content.length === 0;
    }
    put(message: Action<any>): void {
        this.content.push(message);
    }
    take(): Action<any> {
        return this.content.shift();
    }
    flush(): any {
        const result = this.content;
        this.content = [];
        return result;
    }
}
